// This file is part of the Smart Building Message Gateway.
//
//   |     __| _ _|   __|   _ \   \  |
//   |     _|    |   (     (   | |\/ |
//  ____| ___| ___| \___| \___/ _|  _|
//
// Copyright © 2025 LEICOM AG. All Rights Reserved.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
// BUT NOT LIMITED  TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// @author      Christian Stauffer <christian.stauffer@leicom.ch>, et al.

import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RiUser3Fill } from "react-icons/ri";
import { FaUserPen } from "react-icons/fa6";
import { FaUserTimes, FaUserPlus } from "react-icons/fa";
import { MdCancel, MdDone } from "react-icons/md";
import { PiPassword } from "react-icons/pi";



import './User.css'

function User() {

  const [userList, setUserList] = useState([]);

  const [loading, setLoading] = useState(false);

  const location = useLocation();
  // const navigate = useNavigate();

  const apiKey = window.env.API_KEY;
  const api = window.env.API_URL;

  const { token } = location.state || {};

  const remove = async (userID) =>{
    try {
      const response = await fetch(`${api}/user?id=${userID}`, {
        method: "DELETE",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });

      if (response.ok) {
        const user = await response.json()
        
        console.log("Del User: ", user)
        
      } else {
        // setError("cannot edit user");
        console.log("error delete user")
      }

    } catch (err) {
      // setError("cannot edit user");
      console.log("delete user", err)
    }finally{
      fetchUsers();
    }
  }

  const [pwForm, setShowPwForm] = useState(false);
  const [pwFormData, setPwFormData] = useState({
    password:"",
    passwordRepeat:""
  });

  const [userForm, setShowUserForm] = useState(false);
  const [userFormData, setUserFormData] = useState({
    id: 0,
    title: '',
    email: '',
    phone: '',
    name: '',
    customerID: 0,
    password: '',
    enabled: true,
    admin: false,
    mfa: ''
  });

  
  const showPwForm = () => setShowPwForm(true);
  const closePwForm = () => setShowPwForm(false);

  const openUserForm = async (action, userID) => {
    userFormData.id = userID
    userFormData.title = action + " User"

    userFormData.email = ""
    userFormData.phone = ""
    userFormData.name = ""
    userFormData.customerID = null
    userFormData.password = ""
    userFormData.enabled = true
    userFormData.admin = false
    userFormData.mfa = 'none'

    if (userID != null){
      try {
        const response = await fetch(`${api}/user?id=${userID}`, {
          method: "GET",
          headers: {
            "X-Api-Key": `${apiKey}`,
            "Authorization": `${token}`
          },
        });

        if (response.ok) {
          const user = await response.json()
          
          console.log("User", user)

          userFormData.email = user.email
          userFormData.phone = user.phone
          userFormData.name = user.name
          userFormData.customerID = user.customerID
          userFormData.password = user.password
          userFormData.enabled = user.enabled
          userFormData.admin = user.admin
          userFormData.mfa = user.mfa

          setShowUserForm(true);
          
        } else {
          // setError("cannot edit user");
          console.log("error get users")
          setShowUserForm(false);
        }

      } catch (err) {
        // setError("cannot edit user");
        console.log("fetch user", err)
        setShowUserForm(false);
      }
    } else {
      setShowUserForm(true);
    }
  };

  const closeUserForm = () => setShowUserForm(false);

  const handleChangePw = (e) => {
    const { name, type, checked, value } = e.target;
    setPwFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    let newValue;
    if (type === 'checkbox') {
      newValue = checked;
    } else if (type === 'number') {
      newValue = Number(value);
    } else {
      newValue = value;
    }
  
    setUserFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handlePwSubmit = async (e) => {
    e.preventDefault();

    if (pwFormData.password != pwFormData.passwordRepeat){
      alert("password missmatch")
      return
    }

    try {   

      const response = await fetch(`${api}/change-password`, {
        method: "POST",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
        body: JSON.stringify({
          "password": pwFormData.password
        })
      });
      if (response.ok) {        
        console.log("PW Changed")
      } else {
        // setError("Change Password failed");
      }

    } catch (err) {
      alert("cannot change password", err)
    }

    closePwForm();
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true)
    
    var method = "POST"
    var body = {
      "customerID": userFormData.customerID,
      "email": userFormData.email,
      "name": userFormData.name,
      "password": userFormData.password,
      "phone": userFormData.phone,
      "enabled": userFormData.enabled,
      "admin": userFormData.admin,
      "mfa": userFormData.mfa,
    }

    if (userFormData.id != null && userFormData.id > 0){
      method = "PATCH"
      body = {
        "customerID": userFormData.customerID,
        "email": userFormData.email,
        "name": userFormData.name,
        "password": userFormData.password,
        "phone": userFormData.phone,
        "enabled": userFormData.enabled,
        "admin": userFormData.admin,
        "mfa": userFormData.mfa,
        "id": userFormData.id,
      }
    }

    try {
      const response = await fetch(`${api}/user`, {
        method: method,
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const user = await response.json()
        
        console.log("User", user)

        // userFormData.email = user.email
        // userFormData.phone = user.phone
        // userFormData.name = user.name
        // userFormData.customerID = user.customerID
        
      } else {
        // setError("cannot edit user");
        console.log("error update user")
      }

    } catch (err) {
      // setError("cannot edit user");
      console.log("update user", err)
    } finally {
      setLoading(false)
    }

    closeUserForm();
    fetchUsers();
  };

  const fetchUsers = async (e) => {
    try {   

      const response = await fetch(`${api}/user`, {
        method: "GET",
        headers: {
          "X-Api-Key": `${apiKey}`,
          "Authorization": `${token}`
        },
      });
      if (response.ok) {
        const users = await response.json()
        
        console.log("Users", users)
        setUserList(users)
      } else {
        // setError("Cannot fetch Gateways.");
      }

    } catch (err) {
      // handle empty response
      alert("network problems", err)
      return (<Navigate to="/login" />);
    }
  }
  // get users
  useEffect(() => {
      fetchUsers();
    }, [api, token]);

  return (
    <div className="page">
      <div className="header">
          <RiUser3Fill className="menu-icon" />
          <h2>User</h2>
      </div>

      <div className='menubar'>
        <button onClick={showPwForm}><PiPassword /> Password</button>
        <button onClick={() => openUserForm("Add", null)}><FaUserPlus /> Add</button>
      </div>
       
      {userList.map((user, index) => (
        <div className="item">
          <p key={index}>
          <h3>{user.name}</h3>
            <table>
              <tr>
                <td>ID</td><td>{user.id}</td>
              </tr>
              <tr>
                <td>Customer ID</td><td>{user.customerID ? user.customerID : "-"}</td>
              </tr>
              <tr>
                <td>Admin</td><td>{user.admin ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <td>Enabled</td><td>{user.enabled ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <td>Email</td><td>{user.email}</td>
              </tr>
              <tr>
                <td>Phone</td><td>{user.phone}</td>
              </tr>
              <tr>
                <td>Created</td><td>{user.created}</td>
              </tr>
              <tr>
                <td>Last Login</td><td>{user.lastLogin}</td>
              </tr>
              <tr>
                <td>Multi Factor Auth</td><td>{user.mfa}</td>
              </tr>
            </table>
          </p>
          <p>
            <div className='usermenu'>
              <button onClick={() => openUserForm("Edit", user.id)}><FaUserPen /> Edit</button>
              <button onClick={() => remove(user.id)}><FaUserTimes /> Remove</button>
            </div>
          </p>
        </div>
      ))}
    
    {pwForm && (
        <div className="overlay">
          <div className="form-container">
            <h3>Change Password</h3>
            <form onSubmit={handlePwSubmit}>
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={pwFormData.password}
                onChange={handleChangePw}
                required
              />
              <input
                type="password"
                name="passwordRepeat"
                placeholder="Repeat Password"
                value={pwFormData.passwordRepeat}
                onChange={handleChangePw}
                required
              />
              <div className="form-buttons">
                <button type="submit"><MdDone /> Apply</button>
                <button type="button" onClick={closePwForm}><MdCancel /> Cancel</button>
              </div>
            </form>
          </div>
        </div>
    )}
    
    {userForm && (
        <div className="overlay">
          <div className="form-container">
            <h3>{userFormData.title}</h3>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={userFormData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={userFormData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={userFormData.phone}
                onChange={handleChange}
              />
              <input
                type="number"
                name="customerID"
                placeholder="Customer ID"
                value={userFormData.customerID}
                onChange={handleChange}
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={userFormData.password}
                onChange={handleChange}
              />
              <table>
                <tr>
                <td><label>Admin</label></td>
                <td><input
                  type="checkbox"
                  name="admin"
                  checked={userFormData.admin}
                  onChange={handleChange}
                /></td>
                </tr>
                <tr>
                <td><label>Enabled</label></td>
                <td><input
                  type="checkbox"
                  name="enabled"
                  checked={userFormData.enabled}
                  onChange={handleChange}
                /></td>
                </tr>
                <tr>
                <td><label>MFA</label></td>
                <td><select
                  name="mfa"
                  value={userFormData.mfa}
                  onChange={handleChange}
                >
                  <option value="none">None</option>
                  <option value="sms">SMS</option>
                  <option value="otp">OTP</option>
                </select></td>
                </tr>
              </table>
              <div className="form-buttons">
                <button type="submit" disabled={loading}>{loading ? <div className="spinner"></div> : <><MdDone /> Apply</>}</button>
                <button type="button" onClick={closeUserForm}><MdCancel /> Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default User;
